module.exports = __webpack_public_path__ + "img/cpzs.92b32908.png";